module.exports = {
    en: {
        teams: {
            text: 'Sales team',
        }

    },
    ka: {
        teams: {
            text: 'გაყიდვების გუნდი',
        }
    },
    ru: {
        teams: {
            text: 'отдел продаж',
        }
    }
}